import * as R from 'ramda';

export default function RiskController(
  $rootScope,
  $scope,
  $q,

  userService,
  alerts,
  confirmDialog,
  editRiskDialog,
  loaderService,
  riskDataService,
  riskSharedModelService,
  ssDialogService,
  assetDataService,
  deleteRiskConfirmDialog,
  controlDataService,
  editControlDialog,
  controlSharedModelService,
  syncRiskConfirmDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleEditClick = _handleEditClick;
  vm.handleDeleteClick = _handleDeleteClick;
  vm.handleExpandRiskClick = _handleExpandRiskClick;
  vm.handleAddControlClick = _handleAddControlClick;
  vm.handleBulkDeleteChange = _handleBulkDeleteChange;
  vm.handleSyncControlChange = _handleSyncControlChange;
  vm.handleSyncClick = _handleSyncClick;
  vm.hasData = false;

  _activate();

  function _activate() {
    if (vm.assignAsset === true) {
      vm.tooltipAppendToSelector = '#assignAssetDialog';
    } else if (vm.isEditProcessDialog === true) {
      vm.tooltipAppendToSelector = '#editProcessDialog';
    } else if (vm.isApproveProcessDialog === true) {
      vm.tooltipAppendToSelector = '#approvePRAProcessDialog';
    } else if (vm.isEditAssetDialog === true) {
      vm.tooltipAppendToSelector = '#editAssetDialog';
    }
    _initPermissions();
    _initRiskSeverity();
    $scope.$on('refreshRiskControls', (event, opt) => {
      if (opt.risk.customerRiskId === vm.riskDetail.customerRiskId) {
        _getAssignedControl(vm.riskDetail.customerRiskId);
      }
    });

    $scope.$on('refreshRiskAfterSync', () => {
      _refreshRisk(vm.riskDetail.customerRiskId);
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initRiskSeverity() {
    if (vm.riskDetail) {
      riskSharedModelService.transformRiskTop(vm.riskDetail);
      vm.riskDetail = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskDetail);
      vm.riskDetail = riskSharedModelService.transformMeterStatusToRiskType(vm.riskDetail);
      vm.riskDetail = riskSharedModelService.addColorToProbability(vm.riskDetail);
    }
  }

  function _handleEditClick($event) {
    loaderService.showViewLoader = true;
    $q.all([
      // riskDataService.getRiskTypes(),
      // assetDataService.getAssets(),
      getInitRiskAdmin(),
      riskDataService.getRiskById(vm.riskDetail.customerRiskId)
    ]).then((response) => {
      ssDialogService.dialogs.riskAdmin.editRiskDialog = ssDialogService.alert(
        editRiskDialog.getOptions($event, {
          risk: response[1].data.CustomerRisk,
          riskTypes: response[1].data.CustomerRiskTypes,
          assets: response[1].data.CustomerAssetData,
          asset: vm.asset,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
          riskType: vm.riskType,
        })
      );
      loaderService.showViewLoader = false;
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskDialog);
    });
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.riskAdmin.deleteRiskConfirmDialog = ssDialogService.alert(
      deleteRiskConfirmDialog.getOptions($event, {
        asset: vm.asset,
        risk: vm.riskDetail,
        process: vm.process,
        isEditProcessDialog: vm.isEditProcessDialog,
        isApproveProcessDialog: vm.isApproveProcessDialog,
        isPraProcessMain: vm.isPraProcessMain,
        riskType: vm.riskType,
        showSyncAsset: vm.showSyncAsset,
        assetType: vm.assetType,
        isEditAssetDialog: vm.isEditAssetDialog
      })
    );

    ssDialogService.show(ssDialogService.dialogs.riskAdmin.deleteRiskConfirmDialog);
  }

  function _handleExpandRiskClick() {
    if (!vm.hasData) {
      riskDataService.getRisk(vm.riskDetail.customerRiskId).then((response) => {
        vm.riskDetail = angular.copy(response.data);
        vm.riskDetail = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskDetail);
        vm.riskDetail = riskSharedModelService.transformMeterStatusToRiskType(vm.riskDetail);
        vm.riskDetail = riskSharedModelService.addColorToProbability(vm.riskDetail);
        vm.hasData = true;
      });
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleAddControlClick($event) {
    loaderService.showViewLoader = true;
    const control = { customerControlId: 0, customerRiskControl: {} };
    if (vm.riskDetail) {
      control.customerRiskControl.customerRiskId = vm.riskDetail.customerRiskId;
    }
    $q.all([
      controlSharedModelService.initControlAdmin(),
      controlDataService.getControlById(control.customerControlId),
      controlDataService.getControlTypeDefaults(),
    ]).then((response) => {
      // eslint-disable-next-line max-len
      control.controlPreventiveEffectivenessId = response[2].data.controlPreventiveEffectiveness.controlPreventiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlDetectiveEffectivenessId = response[2].data.controlDetectiveEffectiveness.controlDetectiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlCorrectiveEffectivenessId = response[2].data.controlCorrectiveEffectiveness.controlCorrectiveEffectivenessId;
      // eslint-disable-next-line max-len
      control.controlAdministrativeNatureId = response[2].data.controlAdministrativeNature.controlAdministrativeNatureId;
      control.controlTechnicalNatureId = response[2].data.controlTechnicalNature.controlTechnicalNatureId;
      control.controlPhysicalNatureId = response[2].data.controlPhysicalNature.controlPhysicalNatureId;
      control.controlPrimaryControlTypeId = response[2].data.controlPrimaryControlType.controlPrimaryControlTypeId;
      // eslint-disable-next-line max-len
      control.controlCompensatingControlTypeId = response[2].data.controlCompensatingControlType.controlCompensatingControlTypeId;
      // control.controlReviewScheduleId = response[2].data.controlReviewSchedule.controlReviewScheduleId;
      // control.controlReviewType = response[2].data.controlReviewType;
      // control.controlResult = response[2].data.controlResult;

      loaderService.showViewLoader = false;
      ssDialogService.dialogs.controlAdmin.editControlDialog = ssDialogService.alert(
        editControlDialog.getOptions($event, {
          control,
          controlTypes: response[1].data.CustomerControlTypes,
          risks: response[1].data.CustomerRiskData,
          risk: vm.riskDetail,
          controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlDialog);
    });
  }

  function getInitRiskAdmin() {
    if (riskSharedModelService.RiskOnsets && riskSharedModelService.RiskOnsets.length > 0) {
      return Promise.resolve();
    }
    return riskDataService.initRiskAdmin().then((getRiskInitResponse) => {
      if (!getRiskInitResponse.data) {
        alerts.error('Error occurred get risk init data.');
      } else {
        if (getRiskInitResponse.data.RiskOnsets) {
          riskSharedModelService.RiskOnsets = getRiskInitResponse.data.RiskOnsets.result;
        }

        if (getRiskInitResponse.data.RiskForewarnings) {
          riskSharedModelService.RiskForewarnings = getRiskInitResponse.data.RiskForewarnings.result;
        }

        if (getRiskInitResponse.data.RiskDurations) {
          riskSharedModelService.RiskDurations = getRiskInitResponse.data.RiskDurations.result;
        }

        if (getRiskInitResponse.data.RiskDataConfidentialities) {
          riskSharedModelService.RiskDataConfidentialities = getRiskInitResponse.data.RiskDataConfidentialities.result;
        }


        if (getRiskInitResponse.data.RiskDataIntegrities) {
          riskSharedModelService.RiskDataIntegrities = getRiskInitResponse.data.RiskDataIntegrities.result;
        }

        if (getRiskInitResponse.data.RiskDataAvailabilities) {
          riskSharedModelService.RiskDataAvailabilities = getRiskInitResponse.data.RiskDataAvailabilities.result;
        }

        if (getRiskInitResponse.data.RiskDirections) {
          riskSharedModelService.RiskDirections = getRiskInitResponse.data.RiskDirections.result;
        }

        if (getRiskInitResponse.data.RiskTrendings) {
          riskSharedModelService.RiskTrendings = getRiskInitResponse.data.RiskTrendings.result;
        }

        if (getRiskInitResponse.data.RiskAssessmentFrequencies) {
          riskSharedModelService.RiskAssessmentFrequencies = getRiskInitResponse.data.RiskAssessmentFrequencies.result;
        }

        if (getRiskInitResponse.data.RiskProbabilities) {
          riskSharedModelService.RiskProbabilities = getRiskInitResponse.data.RiskProbabilities.result;
        }
      }
    });
  }

  function _getAssignedControl(riskId) {
    riskDataService.getRisk(riskId).then((response) => {
      if (!response.data) {
        alerts.error('Error occurred while get the risk.');
      } else {
        alerts.success('The risk has been retrieved successfully.');
        vm.riskDetail = response.data;
        _initRiskSeverity();
        _transformControl();
        _refreshAsset();
      }
      loaderService.showViewLoader = false;
    });
  }

  function _refreshAsset() {
    $rootScope.$broadcast('refreshAssets', { assetType: vm.riskDetail.customerAsset });
  }

  function _handleBulkDeleteChange() {
    $rootScope.$broadcast('selectBulkRiskChange');
  }

  function _handleSyncControlChange() {
    $rootScope.$broadcast('selectSyncControlChange');
  }

  function _handleSyncClick($event) {
    ssDialogService.dialogs.riskAdmin.syncRiskDialog = ssDialogService.alert(
      syncRiskConfirmDialog.getOptions($event, {
        risk: vm.riskDetail,
        riskType: vm.riskType,
        isMultipleControls: false,
        updateCallBack: _broadcastEvents,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.riskAdmin.syncRiskDialog);
  }

  function _broadcastEvents() {
    if (vm.showSyncRisk === true) {
      $rootScope.$broadcast('refreshSyncRisks', { customerRiskId: vm.riskDetail.customerRiskId });
      $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType });
    } else if (vm.asset) {
      $rootScope.$broadcast('refreshAssetRisks', { asset: vm.asset });
    } else {
      $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType, risk: vm.riskDetail });
    }
  }

  function _transformControl() {
    if (vm.riskDetail.customerControls && vm.riskDetail.customerControls.length > 0) {
      R.forEach(
        (item) => {
          controlSharedModelService.transformControl(item);
        },
        vm.riskDetail.customerControls
      );
    }
  }

  function _refreshRisk() {
      if (vm.hasData) {
        riskDataService.getRisk(vm.riskDetail.customerRiskId).then((response) => {
          vm.riskDetail = angular.copy(response.data);
          vm.riskDetail = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskDetail);
          vm.riskDetail = riskSharedModelService.transformMeterStatusToRiskType(vm.riskDetail);
          vm.riskDetail = riskSharedModelService.addColorToProbability(vm.riskDetail);
          vm.hasData = true;
        });
      }
  }
}

RiskController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'userService',
  'alerts',
  'confirmDialog',
  'editRiskDialog',
  'loaderService',
  'riskDataService',
  'riskSharedModelService',
  'ssDialogService',
  'assetDataService',
  'deleteRiskConfirmDialog',
  'controlDataService',
  'editControlDialog',
  'controlSharedModelService',
  'syncRiskConfirmDialog'
];
